import { initialState } from "../service.slice";

const resetServices = () => {
    return initialState;
}

export default resetServices;